import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const replacePreset = (config, next)=>_object_spread_props(_object_spread({}, config), {
        presets: config.presets.map((p)=>p.id === next.id ? next : p)
    });
export const addPreset = (config, next)=>_object_spread_props(_object_spread({}, config), {
        presets: [
            ...config.presets,
            next
        ]
    });
export const isDuplicateName = (presets, name, excludingId)=>presets.some((p)=>p.id !== excludingId && p.name.trim().toLowerCase() === name.trim().toLowerCase());
export const isPresetMapped = (preset)=>{
    var _ref;
    var _preset_mappingStatus;
    return (_ref = preset === null || preset === void 0 ? void 0 : (_preset_mappingStatus = preset.mappingStatus) === null || _preset_mappingStatus === void 0 ? void 0 : _preset_mappingStatus.some((m)=>m.status !== 'unmapped')) !== null && _ref !== void 0 ? _ref : false;
};
export const presetMappingStatusFor = (preset, integrationName)=>{
    var _ref;
    var _preset_mappingStatus_find, _preset_mappingStatus;
    return (_ref = (_preset_mappingStatus = preset.mappingStatus) === null || _preset_mappingStatus === void 0 ? void 0 : (_preset_mappingStatus_find = _preset_mappingStatus.find((m)=>m.integrationName === integrationName)) === null || _preset_mappingStatus_find === void 0 ? void 0 : _preset_mappingStatus_find.status) !== null && _ref !== void 0 ? _ref : 'unmapped';
};
